import { IRecommendationAdjustedTask } from './recommendation-task';
import { IFilterValue } from '../filter-value';
import { BaseRecommendationSegmentWithParts } from './base-recommendation-segment';
import { IBasicOrganisationInfo } from '../telephony/basic-organisation-info';
import { IRecommendationTaskToTaskSegment } from './recommendation-task-to-task-segment';
import { RouteRecommendationTypeEnum } from '../../enums/route-recommendation-type.enum';
import { ISupplier } from '../supplier';
import { IRouteAlert } from './route-alert';
import { IRouteGrabBonus } from './route-grab-bonus';
import { IRouteRecommendationAlternateDate } from './route-recommendation-alternate-date';

export interface IRouteRecommendationResult {
  routes: IRouteRecommendation[];
  total: number;
}

export interface IRouteRecommendation {
  id: number;
  startDay: Date;
  leaveHomeEarliest: string;
  leaveHomeLatest: string;
  arriveHomeEarliest: string;
  arriveHomeLatest: string;
  totalTime: number;
  poundPerHour: number;
  probabilityLateDayOne: number;
  probabilityLateDayTwo: number;
  recommendationScore: number;
  recommendationTasks: IRecommendationAdjustedTask[];
  supplierToTaskSegment: BaseRecommendationSegmentWithParts;
  taskToSupplierSegment: BaseRecommendationSegmentWithParts;
  taskToTaskSegments: IRecommendationTaskToTaskSegment[];
  watched: boolean;
  hidden: boolean;
  invalidated: boolean;
  deletePending?: boolean;

  hasCarryOver: boolean;
  carryOverCount: number;
  supplier: IBasicOrganisationInfo;

  totalTaskMiles: number;
  taskCount: number;

  totalTravelCosts: number;
  minTravelCosts: number;
  maxTravelCosts: number;

  routeRecommendationType: RouteRecommendationTypeEnum;

  supplierDetail?: ISupplier | null;

  hasGrabbedTasks: boolean;

  routeNumber: string;

  // Calculated field, not on model
  totalIncome: number;
  routeGrabbed: boolean;
  supplierPrice: number;
  priceIncreasePercentage?: number;
  isDuplicate?: boolean;
  deDupeId?: string;
  duplicateCount?: number;
  isNew?: boolean;

  showCosts: boolean;
  routeAlerts?: IRouteAlert[];
  grabBonus?: IRouteGrabBonus | null;

  // Day-toggle variants (date/carryover options) of this route, supplied inline by search.
  variants?: IRouteRecommendationAlternateDate[];

  //Only for Grabbed Routes
  jobId?: number | null;
}

export enum IGrabRouteRecommendationResultFailure {
  NoLongerAvailable = 0,
  TechnicalError = 1,
}

export interface IGrabRouteRecommendationResult {
  success: boolean;
  failure: IGrabRouteRecommendationResultFailure;
  newJobId?: number;
}

export interface IRouteRecommendationSearchFilters {
  organisationId?: IFilterValue<number>;
  noCarryOvers: IFilterValue<boolean>;
  dateRange: IFilterValue<string[]>;
  maxNumberOfTasks: IFilterValue<number | null>;
  component: IFilterValue<number>;
  extender: IFilterValue<number>;
  extenderSelectedJobs: IFilterValue<number[]>;
  supplierId: IFilterValue<number | null>;
  jobNumberOrVehicleReg: IFilterValue<string>;
  excludeClashSeverities: IFilterValue<string[]>;
}

export interface IRouteRecommendationSearch {
  filters: IRouteRecommendationSearchFilters;
  first?: number;
  rows?: number;
  sortOrder?: number;
  sortField?: string;
}
